import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import EmbalajeGrupo from './EmbalajeGrupo';
import ACCESS from '../../../ACCESS.js';

class EmbalajeGrupos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'embalaje-grupo/filter', deleteUrl: 'embalaje-grupo/delete', deleteField: 'grupo', modUrl: '/Catalogo/GrupoEmbalaje' },
      TableOp.Table('Grupos de Embalaje', [
        { label: 'Grupo', id: 'grupo' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_EMBALAJES.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_EMBALAJES.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <EmbalajeGrupo  onSave={() => {this.table()}}></EmbalajeGrupo>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(EmbalajeGrupos)